import { toSingleParam } from './funnelContext';

export const NEWSLETTER_SUBSCRIBE_QUERY_KEY = 'newsletter_subscribe';
export const NEWSLETTER_SUBSCRIBED_QUERY_KEY = 'newsletter_subscribed';
export const NEWSLETTER_SUBSCRIBE_ERROR_QUERY_KEY = 'newsletter_subscribe_error';

export type NewsletterSubscribeRouteState = 'request' | 'success' | 'error' | 'clear';

export function hasNewsletterSubscribeRequest(
    params: Record<string, string | string[] | undefined>
): boolean {
    return toSingleParam(params[NEWSLETTER_SUBSCRIBE_QUERY_KEY]) === '1';
}

export function hasNewsletterSubscribeSuccess(
    params: Record<string, string | string[] | undefined>
): boolean {
    return toSingleParam(params[NEWSLETTER_SUBSCRIBED_QUERY_KEY]) === '1';
}

export function hasNewsletterSubscribeError(
    params: Record<string, string | string[] | undefined>
): boolean {
    return toSingleParam(params[NEWSLETTER_SUBSCRIBE_ERROR_QUERY_KEY]) === '1';
}

export function buildRouteWithNewsletterState(
    route: string,
    state: NewsletterSubscribeRouteState
): string {
    const queryStartIndex = route.indexOf('?');
    const pathname = queryStartIndex >= 0 ? route.slice(0, queryStartIndex) : route;
    const query = queryStartIndex >= 0 ? route.slice(queryStartIndex + 1) : '';
    const searchParams = new URLSearchParams(query);

    searchParams.delete(NEWSLETTER_SUBSCRIBE_QUERY_KEY);
    searchParams.delete(NEWSLETTER_SUBSCRIBED_QUERY_KEY);
    searchParams.delete(NEWSLETTER_SUBSCRIBE_ERROR_QUERY_KEY);

    if (state === 'request') {
        searchParams.set(NEWSLETTER_SUBSCRIBE_QUERY_KEY, '1');
    } else if (state === 'success') {
        searchParams.set(NEWSLETTER_SUBSCRIBED_QUERY_KEY, '1');
    } else if (state === 'error') {
        searchParams.set(NEWSLETTER_SUBSCRIBE_ERROR_QUERY_KEY, '1');
    }

    const nextQuery = searchParams.toString();
    return nextQuery ? `${pathname}?${nextQuery}` : pathname;
}
